/**
 * Mobile Card Component
 * Touch-optimized card with gesture support and mobile animations
 */

import React from 'react';
import { motion } from 'framer-motion';
import { getMobileStyles } from '../styles/mobileDesignSystem';

const MobileCard = ({ 
  children, 
  variant = 'ysr2', 
  className = '', 
  onClick,
  animate = true,
  title,
  subtitle,
  icon,
  onTap,
  onDoubleTap,
  onLongPress,
  ...props 
}) => {
  const cardStyles = getMobileStyles.card(variant);
  const animationProps = animate ? getMobileStyles.animation.slideUp : {};

  const Component = (onClick || onTap) ? motion.button : motion.div;
  const componentProps = {};
  
  if (onClick) {
    componentProps.onClick = onClick;
    componentProps.whileTap = { scale: 0.98 };
  }
  
  if (onTap) {
    componentProps.onClick = onTap;
    componentProps.whileTap = { scale: 0.98 };
  }
  
  if (onDoubleTap) {
    componentProps.onDoubleClick = onDoubleTap;
  }
  
  if (onLongPress) {
    componentProps.onTouchStart = (e) => {
      const timer = setTimeout(() => {
        onLongPress(e);
      }, 500);
      componentProps.onTouchEnd = () => clearTimeout(timer);
    };
  }

  return (
    <Component
      className={`${cardStyles} ${className}`}
      {...animationProps}
      {...componentProps}
      {...props}
    >
      {(title || icon || subtitle) && (
        <div className="mb-4">
          {icon && (
            <div className="text-2xl mb-2">{icon}</div>
          )}
          {title && (
            <h3 className="text-lg font-semibold text-white mb-1">{title}</h3>
          )}
          {subtitle && (
            <p className="text-sm text-gray-400">{subtitle}</p>
          )}
        </div>
      )}
      {children}
    </Component>
  );
};

export default MobileCard;
